import { render, staticRenderFns } from "./gBJiLuDialog.vue?vue&type=template&id=36efb6c8&"
import script from "./gBJiLuDialog.vue?vue&type=script&lang=js&"
export * from "./gBJiLuDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports